export interface SpecialEntry {
  title: string;
  desc: string;
  link: string;
  type: string;
}

export interface SpecialGroup {
  name: string;
  desc: string;
  entries: SpecialEntry[];
}

export interface SpecialItem {
  id: string;
  title: string;
  cover: string;
  intro: string;
  reason: string;
  groups: SpecialGroup[];
}

export const specialsList: SpecialItem[] = [
  {
    id: "season-2026-autumn",
    title: "2026 秋季新番前瞻",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20an%20autumn%20city%20street%20with%20falling%20maple%20leaves%20and%20glowing%20movie%20posters%2C%20warm%20orange%20and%20amber%20tones%20with%20teal%20accents%2C%20cel%20shaded%20anime%20art%20style%2C%20cozy%20cinematic%20composition&width=1200&height=800&seq=special-cover-autumn&orientation=landscape",
    intro: "秋季新番集中来袭，哪些作品值得放进追番清单？我们为你整理了一份前瞻指南。",
    reason: "覆盖科幻、奇幻、恋爱等多个类型，帮你快速锁定本季最值得期待的新作。",
    groups: [
      {
        name: "热血冒险档",
        desc: "适合喜欢燃系剧情的观众，节奏明快、主线清晰。",
        entries: [
          { title: "《星海航路》第二季定档十月", desc: "科幻冒险强势回归，全新星域等待探索。", link: "/news/starsea-season2", type: "资讯" },
          { title: "《剑与旅人》动画化公布", desc: "人气奇幻漫画改编，主视觉图气势十足。", link: "/recommend/sword-and-traveler", type: "作品" },
          { title: "《灵域少年》热血成长线", desc: "前期铺垫后进入高潮，值得坚持。", link: "/recommend/spirit-boy", type: "作品" },
        ],
      },
      {
        name: "治愈日常档",
        desc: "想要放松心情时，这些温柔的作品正合适。",
        entries: [
          { title: "《甜点魔法屋》温暖开播", desc: "甜点与回忆交织的单元剧。", link: "/recommend/sweet-magic-house", type: "作品" },
          { title: "《南风物语》剧场版热映", desc: "夏日海街的告别与重逢。", link: "/news/southwind-movie", type: "资讯" },
          { title: "《月下咖啡厅》新角色登场", desc: "夜晚咖啡厅的群像故事。", link: "/news/moonlight-cafe-cast", type: "资讯" },
        ],
      },
    ],
  },
  {
    id: "classic-recall",
    title: "经典回顾：那些年我们追过的动画",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20nostalgic%20retro%20living%20room%20with%20an%20old%20television%20and%20stacks%20of%20DVD%20cases%2C%20warm%20sepia%20and%20amber%20tones%20with%20soft%20teal%20shadows%2C%20cel%20shaded%20anime%20art%20style%2C%20sentimental%20composition&width=1200&height=800&seq=special-cover-classic&orientation=landscape",
    intro: "重温那些曾经陪伴我们成长的经典作品，找回最初的感动。",
    reason: "以时间为线索梳理经典作品的脉络，适合想要系统回顾的动漫爱好者。",
    groups: [
      {
        name: "氛围至上",
        desc: "以独特的气质和沉浸感著称，值得反复回味。",
        entries: [
          { title: "《极光列车》悬疑氛围标杆", desc: "雪原夜行，谜团层层递进。", link: "/recommend/aurora-train", type: "作品" },
          { title: "《荒野之诗》公路剧式的浪漫", desc: "一路向西的孤独旅程。", link: "/recommend/wilderness-poem", type: "作品" },
        ],
      },
      {
        name: "情感共鸣",
        desc: "以细腻的情感刻画打动人心。",
        entries: [
          { title: "《花间绮谭》古风唯美情缘", desc: "跨越身份与命运的相遇。", link: "/recommend/flower-tale", type: "作品" },
          { title: "《夏日回响》完结篇", desc: "烟火与告别的夏日记忆。", link: "/news/summer-echo-finale", type: "资讯" },
        ],
      },
    ],
  },
  {
    id: "guoman-rising",
    title: "国漫崛起：值得关注的原创力量",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20modern%20studio%20workspace%20with%20glowing%20concept%20art%20screens%20showing%20ancient%20Chinese%20mountains%2C%20teal%20green%20and%20warm%20gold%20accents%2C%20cel%20shaded%20anime%20art%20style%2C%20creative%20cinematic%20composition&width=1200&height=800&seq=special-cover-guoman&orientation=landscape",
    intro: "近年来国产动画不断突破，从题材到美术都展现出令人惊喜的创造力。",
    reason: "聚焦原创国漫的成长轨迹，帮助读者发现被低估的优质作品。",
    groups: [
      {
        name: "古风与江湖",
        desc: "以东方美学为核心，构建独特的视觉世界。",
        entries: [
          { title: "《山河引》水墨与赛璐璐的融合", desc: "被观众称为年度最值得一看的国漫。", link: "/recommend/mountain-river", type: "作品" },
          { title: "《花间绮谭》唯美古风情缘", desc: "花会之下的缘分生长。", link: "/recommend/flower-tale", type: "作品" },
        ],
      },
      {
        name: "口碑与讨论",
        desc: "近期讨论度最高的国漫话题。",
        entries: [
          { title: "《山河引》口碑逆袭", desc: "评分持续攀升的背后。", link: "/news/mountain-river-score", type: "资讯" },
        ],
      },
    ],
  },
  {
    id: "sci-fi-collection",
    title: "科幻机甲特辑：想象力的边界",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20hangar%20with%20a%20giant%20mecha%20under%20maintenance%20and%20engineers%20working%2C%20glowing%20orange%20and%20teal%20lights%2C%20cel%20shaded%20mecha%20anime%20art%20style%2C%20industrial%20cinematic%20composition&width=1200&height=800&seq=special-cover-scifi&orientation=landscape",
    intro: "科幻与机甲的浪漫，在于对未来的无限想象，也在于机械之下的温度。",
    reason: "为科幻爱好者精选设定扎实、美术出众的机甲与未来题材作品。",
    groups: [
      {
        name: "硬核设定",
        desc: "世界观构建严谨，细节经得起推敲。",
        entries: [
          { title: "《机械都市 2099》制作特辑", desc: "揭秘世界观与机甲设计思路。", link: "/news/mecha-city-featurette", type: "资讯" },
          { title: "《机械都市 2099》未来都市物语", desc: "秩序与自由之间的抉择。", link: "/recommend/mecha-city", type: "作品" },
        ],
      },
      {
        name: "速度与热血",
        desc: "以竞技与速度点燃肾上腺素。",
        entries: [
          { title: "《未来方程式》竞速新美学", desc: "科技竞速成为主流运动的未来。", link: "/recommend/future-equation", type: "作品" },
          { title: "《星海航路》横跨星海的旅程", desc: "太空冒险的宏大叙事。", link: "/recommend/starsea-route", type: "作品" },
        ],
      },
    ],
  },
];